var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSwapHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81445 10.0566L2.88477 12H10.5V13.5H2.8457L4.81445 15.4434L3.75 16.5L0 12.75L3.75 9L4.81445 10.0566Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 3C23.3271 3 24 3.6729 24 4.5V12C24 12.8271 23.3271 13.5 22.5 13.5H15C14.1729 13.5 13.5 12.8271 13.5 12V4.5C13.5 3.6729 14.1729 3 15 3H22.5ZM15 12H22.5V4.5H20.25V8.25H17.25V4.5H15V12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.75L6.75 7.5L5.68555 6.44336L7.61523 4.5H0V3H7.6543L5.68555 1.05664L6.75 0L10.5 3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSwapHorizontal);
export default __webpack_public_path__ + "static/media/ic-swap-horizontal.ead1a741638e911d57669b471fba335b.svg";
export { ForwardRef as ReactComponent };